// Used in many components

import { Injectable } from "@angular/core";
import { assetActivityTypeIds, assetTypeIds } from "@carnegie-learning/cure-types";
import { PPAssignment as Assignment } from "cli-types";

@Injectable()
export class GetGradesHelper {
    overdue = false;
    grade: string | number = "";
    evaluatorScore: number;
    selectedGrade: any;
    readonly assetActivityTypeIds = assetActivityTypeIds;

    constructor() {}

    // format an assignment's score/score possible
    public getGrades(assignment: Assignment) {
        this.grade = "---"; // Default grade value

        if (this.isMathiaWorkspace(assignment)) {
            return this.grade;
        }

        if (this.getScorePossible(assignment) !== null) {
            this.grade =
                this.getCurrentScore(assignment) +
                "/" +
                this.getScorePossible(assignment);
        }
        return this.grade;
    }

    // format an assignment's score/score possible
    public getGradeAsPercent(assignment: Assignment) {
        let percentConcat = "---";
        if (this.isMathiaWorkspace(assignment)) {
            return percentConcat;
        }
        // It looks like this was written to account for the possibility that scorePossible might not really be a number. The following conditional is to ensure that it is.
        const scorePossible: number | undefined =
            this.getScorePossible(assignment);
        if (scorePossible) {
            if (assignment.evaluatorScore || assignment.evaluatorScore === 0) {
                const score = this.getCurrentScore(assignment);
                percentConcat =
                    Math.round(
                        (<number>score / scorePossible) * 100
                    ).toString() + "%";
            }
        }
        return percentConcat;
    }

    public getGradeWithoutScorePossible(assignment: Assignment) {
        this.grade = "---"; // Default grade value
        if (this.isMathiaWorkspace(assignment)) {
            return this.grade;
        }
        if (
            assignment &&
            assignment.evaluatorScore !== null &&
            this.getScorePossible(assignment) !== null
        ) {
            this.grade = this.getCurrentScore(assignment);
        }
        return this.grade;
    }

    // Current Score
    getCurrentScore(assignment: Assignment) {
        this.grade = "---";
        if (this.isMathiaWorkspace(assignment)) {
            return this.grade;
        }
        if (assignment.evaluatorScore || assignment.evaluatorScore === 0) {
            this.evaluatorScore = assignment.evaluatorScore;
            this.grade = this.evaluatorScore;
            if (assignment.shortAssignableType === assetTypeIds.PERFORM) {
                if (this.getScorePossible(assignment) === 0) {
                    // for non-graded avenue tasks
                    if (assignment.completedAt) {
                        this.grade = 1;
                    } else if (this.overdue) {
                        this.grade = 0;
                    }
                }
            }
        }

        return this.grade;
    }

    getScorePossible(assignment: Assignment) {
        return assignment.scorePossible;
    }

    // The max a score can be is double the score possible
    getMaxScoreInputReached(assignment: Assignment, score: number) {
        if (assignment) {
            const scorePossible = this.getScorePossible(assignment);
            if (scorePossible) {
                return score > scorePossible * 2;
            }
        }
    }
    // Get the value of what the max score can be
    getMaxScoreValue(assignment: Assignment) {
        if (assignment) {
            const scorePossible = this.getScorePossible(assignment);
            if (scorePossible) {
                return scorePossible * 2;
            }
        }
    }

    isMathiaWorkspace(assignment: Assignment): boolean {
        if (
            assignment.assignableType === assetActivityTypeIds.MATHIA_UNIT ||
            assignment.shortAssignableType === assetTypeIds.COG_TUTOR
        ) {
            return true;
        }

        return false;
    }
}
